import { useMemo } from 'react';
import { createTheme } from '@mui/material/styles';
import { themeOptions } from 'assets/theme';
import { themeOptions as darkThemeOptions } from 'assets/theme-dark';
import { changeColor } from 'utils/colorUtils';
import boxShadow from 'assets/theme-dark/functions/boxShadow';
import { frFR } from '@mui/material/locale';

/**
 * Hook used to handle theme.
 */
export const useThemeBuilder = (primaryColor, secondaryColor) => {
  const lightTheme = useMemo(
    () => builTheme(false, primaryColor, secondaryColor),
    [primaryColor, secondaryColor]
  );
  const darkTheme = useMemo(
    () => builTheme(true, primaryColor, secondaryColor),
    [primaryColor, secondaryColor]
  );

  function builTheme(darkMode, primaryColor, secondaryColor) {
    const blackMainColor =
      (!darkMode ? themeOptions : darkThemeOptions).palette.colors?.black.main ?? '#000000';
    return createTheme(
      !darkMode ? themeOptions : darkThemeOptions,
      {
        palette: {
          primary: {
            main: primaryColor,
            focus: changeColor(primaryColor, 10)
          },
          secondary: {
            main: secondaryColor,
            focus: changeColor(secondaryColor, 10)
          },
          gradients: {
            primary: {
              main: primaryColor,
              state: changeColor(primaryColor, 30)
            },
            secondary: {
              main: secondaryColor,
              state: changeColor(secondaryColor, 30)
            }
          },
          coloredShadows: {
            primary: primaryColor,
            secondary: secondaryColor
          }
        },
        boxShadows: {
          colored: {
            primary: `${boxShadow([0, 4], [20, 0], blackMainColor, 0.14)}, ${boxShadow(
              [0, 7],
              [10, -5],
              primaryColor,
              0.7
            )}`,
            secondary: `${boxShadow([0, 4], [20, 0], blackMainColor, 0.14)}, ${boxShadow(
              [0, 7],
              [10, -5],
              secondaryColor,
              0.7
            )}`
          }
        }
      },
      frFR
    );
  }

  return { darkTheme, lightTheme };
};
